// Passcode gate. The viewer code lets people watch; the admin code adds the
// control panel, owner chat and the keyboard drive.
import { useState, type FormEvent } from 'react';
import { useAction } from 'convex/react';
import { api } from '../../convex/_generated/api';
import { COMPANY } from '../../convex/shared/scenario';
import { Logo } from '../ui/Logo';
import { useSession } from '../lib/session';
import { Avatar } from '../ui/Avatar';
import { Button } from '../ui/primitives';

const PARADE = ['mari', 'dana', 'wes', 'priya', 'gus', 'bev', 'kai', 'rosa'];

export function LoginView() {
  const login = useAction(api.spectate.auth.login);
  const { signIn } = useSession();
  const [passcode, setPasscode] = useState('');
  const [label, setLabel] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!passcode.trim()) return;
    setBusy(true);
    setError(null);
    try {
      const r = await login({ passcode, label: label.trim() || undefined });
      if (r.ok) signIn(r.token);
      else setError(r.reason);
    } catch {
      setError('The gate is not answering. Try again in a moment.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <div className="login-sky" aria-hidden>
        <span className="cloud c1" />
        <span className="cloud c2" />
        <span className="cloud c3" />
      </div>
      <form className="login-card panel" onSubmit={submit}>
        <Logo />
        <p className="login-tag">
          A living day at <b>{COMPANY.name}</b>, {COMPANY.city}. {COMPANY.tagline}
        </p>
        <div className="login-parade" aria-hidden>
          {PARADE.map((k, i) => (
            <span key={k} style={{ animationDelay: `${i * 90}ms` }}>
              <Avatar personaKey={k} mood={0.5} size={40} />
            </span>
          ))}
        </div>
        <label className="field">
          <span>Passcode</span>
          <input type="password" autoComplete="current-password" value={passcode} onChange={(e) => setPasscode(e.target.value)} autoFocus required />
        </label>
        <label className="field">
          <span>Your name (optional)</span>
          <input type="text" maxLength={40} value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Shown to other spectators" />
        </label>
        {error ? (
          <p className="form-error" role="alert">
            {error}
          </p>
        ) : null}
        <Button type="submit" tone="sun" size="lg" icon="play" disabled={busy || !passcode.trim()}>
          {busy ? 'Opening' : 'Enter the world'}
        </Button>
      </form>
    </div>
  );
}
